import { InMemoryCache } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import fetch from 'cross-fetch'

// Reusable merge function that prioritizes incoming data
const mergePrioritizeIncoming = (existing = [], incoming) => {
  // Create a Set of incoming reference IDs
  const incomingIds = new Set(incoming.map(ref => ref.__ref))

  // Filter out existing references that are in the incoming set
  const uniqueExisting = existing.filter(ref => !incomingIds.has(ref.__ref))

  // Return incoming references first, followed by unique existing ones
  return [...incoming, ...uniqueExisting]
}

export default function ({ app }) {
  const language = app.i18n.locale
  return {
    defaultHttpLink: false,
    link: createUploadLink({
      uri: process.env.GRAPHQL_API_URL || 'http://localhost:1337/graphql',
      fetch,
      headers: {
        'Accept-Language': language || 'fr',
      },
    }),
    cache: new InMemoryCache({
      typePolicies: {
        Report: {
          // Ensure objects can be identified with `client.cache.identify({ __typename: typeName, id })`
          keyFields: ['id'],
          fields: {
            reportPeople: {
              merge: mergePrioritizeIncoming,
            },
            reportAnswers: {
              merge: mergePrioritizeIncoming,
            },
            reportDocuments: {
              merge: mergePrioritizeIncoming,
            },
            reportOrders: {
              merge: mergePrioritizeIncoming,
            },
          },
        },
      },
    }),
  }
}
